module.exports = __webpack_public_path__ + "img/users-solid.42803404.svg";